import { call, put, takeLatest } from "redux-saga/effects";
import { easySwitch } from "sc/helpers/switch";
import { LOGIN, loggedIn } from "sc/ui/sites/oncall/actions/auth";
import login, { AUTHENTICATION_FAILED } from "sc/backend/oncall/public/login";
import { uiError } from "sc/actions/ui/ui-error";
import {
  ERROR_SOMETHING_WENT_WRONG,
  ERROR_AUTHENTICATION_FAILED,
} from "sc/ui/sites/oncall/components/forms/LoginForm";

const loginSaga = function*(action) {
  try {
    const result = yield call(
      login,
      action.payload.username,
      action.payload.password,
    );

    let resultAction = null;
    if (result.token) {
      resultAction = loggedIn(result);
    } else {
      resultAction = easySwitch(result, {
        [AUTHENTICATION_FAILED]: () => uiError(ERROR_AUTHENTICATION_FAILED),
      });
    }

    yield put(resultAction);
  } catch (ignore) {
    yield put(uiError(ERROR_SOMETHING_WENT_WRONG));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(LOGIN, loginSaga);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/login.js